import React, { useEffect } from "react";
// import "./projects.css";
import Navbar from "../../components/navbar/Navbar";
import Footer from "../../components/footer/Footer";
import HomeProjects from "../../components/homeProjects/HomeProjects";
import OurProjects from "../ourProjects/OurProjects";
import { useLocation } from "react-router-dom";
import SEO from "../../components/SEO/SEO";
import {
  abia_four,
  abia_one,
  abia_three,
  abia_two,
  agege_one,
  agege_two,
  corp_mem,
  enugu_one,
  enugu_three,
  enugu_two,
  iju_eight,
  iju_eleven,
  iju_five,
  iju_four,
  iju_nine,
  iju_one,
  iju_seven,
  iju_six,
  iju_ten,
  iju_three,
  iju_two,
  ikd_eight,
  ikd_eleven,
  ikd_five,
  ikd_four,
  ikd_nine,
  ikd_one,
  ikd_seven,
  ikd_six,
  ikd_ten,
  ikd_three,
  ikd_twelve,
  ikd_two,
  ipaja_one,
  ipaja_two,
  isheri_one,
  isheri_two,
  laspotech_eight,
  laspotech_five,
  laspotech_four,
  laspotech_one,
  laspotech_seven,
  laspotech_six,
  laspotech_three,
  laspotech_two,
  primary_four,
  primary_one,
  primary_three,
  primary_two,
  secondary_eight,
  secondary_five,
  secondary_four,
  secondary_nine,
  secondary_one,
  secondary_seven,
  secondary_six,
  secondary_ten,
  secondary_three,
  secondary_two,
  women_eight,
  women_five,
  women_four,
  women_one,
  women_seven,
  women_six,
  women_three,
  women_two,
  youth_eight,
  youth_five,
  youth_four,
  youth_one,
  youth_three,
  youth_two,
} from "../../assets";

const Projects = () => {
  const imagesPrint = [
    laspotech_two,
    laspotech_five,
    laspotech_eight,

    laspotech_four,
    laspotech_one,
    laspotech_seven,
    laspotech_six,
    laspotech_three,
  ];

  const secondaryPrint = [
    secondary_seven,
    secondary_six,
    secondary_eight,
    secondary_five,
    secondary_four,

    secondary_one,

    secondary_ten,
    secondary_three,
    secondary_two,
  ];

  const primaryPrint = [primary_one, primary_four, primary_three, primary_two];
  const youthPrint = [
    youth_eight,
    youth_five,
    youth_four,
    youth_one,
    youth_three,

    youth_two,
  ];

  const womenPrint = [
    women_eight,
    women_five,
    women_four,
    women_one,
    women_seven,

    women_six,
    women_three,
    women_two,
  ];

  const ijuPrint = [
    iju_six,
    iju_ten,
    iju_three,
    iju_eight,
    iju_eleven,
    iju_five,
    iju_four,
    iju_nine,

    iju_one,
    iju_seven,

    iju_two,
  ];

  const ikdPrint = [
    ikd_eight,
    ikd_eleven,
    ikd_five,
    ikd_four,
    ikd_nine,
    ikd_one,
    ikd_seven,
    ikd_six,
    ikd_ten,
    ikd_three,
    ikd_twelve,
    ikd_two,
  ];

  const nyscPrint = [corp_mem];
  const agegePrint = [agege_one, agege_two];

  const abiaPrint = [abia_one, abia_three, abia_two, abia_four];

  const isheriPrint = [isheri_one, isheri_two];

  const ipajaPrint = [ipaja_one, ipaja_two];

  const enuguPrint = [enugu_one, enugu_three, enugu_two];
  const location = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);
  return (
    <div>
      <SEO
        title="Our Projects"
        description="View Swadaa Security & Guards Limited community impact projects: school awareness lectures, women and youth empowerment programs, and regional safety initiatives across Lagos and beyond."
        keywords="Swadaa projects, community safety, school awareness programs, youth empowerment, women empowerment, regional chapters, social impact"
      />
      <Navbar />
      <div className="home_projects_body">
        <div className="home_project_section_headinggg">
          Our lectures in various schools
        </div>
        <OurProjects
          imageFiles={imagesPrint}
          projectHeading="Lagos State University of Science and Technology"
        />
        <OurProjects
          imageFiles={secondaryPrint}
          projectHeading="Various Secondary Schools -Interstate"
        />
        <OurProjects
          imageFiles={primaryPrint}
          projectHeading="Various Primary Schools -Interstate"
        />

        <OurProjects
          imageFiles={nyscPrint}
          projectHeading="Inconjunction with NYSC"
        />

        <div className="home_project_section_headinggg">
          Empowerment Program
        </div>

        <OurProjects
          imageFiles={womenPrint}
          projectHeading="Widows & Women Empowerment"
        />

        <OurProjects
          imageFiles={youthPrint}
          projectHeading="Youth Empowerment (Vocational Programme)"
        />

        <div className="home_project_section_headinggg">Regional Chapters</div>
        <OurProjects
          imageFiles={ijuPrint}
          projectHeading="Iju Ishaga, Lagos State Chapter"
        />
        <OurProjects
          imageFiles={agegePrint}
          projectHeading="Agege, Lagos State Chapter"
        />
        <OurProjects
          imageFiles={ikdPrint}
          projectHeading="Ikorodu, Lagos State Chapter"
        />
        <OurProjects
          imageFiles={isheriPrint}
          projectHeading="Isheri, Lagos State Chapter"
        />
        <OurProjects
          imageFiles={ipajaPrint}
          projectHeading="Ipaja, Lagos State Chapter"
        />
        <OurProjects
          imageFiles={abiaPrint}
          projectHeading="Abia State Chapter"
        />
        <OurProjects
          imageFiles={enuguPrint}
          projectHeading="Enugu State Chapter"
        />
      </div>
      <Footer />
    </div>
  );
};

export default Projects;
